module.exports = __webpack_public_path__ + "media/images/redes_sociales/twitter-b4b62479092fbf5331db2e8a05bd9de8.svg";